import React from 'react';
import { FiClock, FiShield, FiUsers, FiMessageSquare } from 'react-icons/fi';

const items = [
  {
    icon: <FiClock className="h-5 w-5" />,
    iconClass: 'bg-[#e9f2fb] text-[#2b6cb0]',
    title: '24/7 Availability',
    text: 'Request support any time through our service desk.',
  },
  {
    icon: <FiShield className="h-5 w-5" />,
    iconClass: 'bg-[#fff1e8] text-[var(--brand-accent)]',
    title: 'Secure Handling',
    text: 'Your request details are processed through a protected flow.',
  },
  {
    icon: <FiUsers className="h-5 w-5" />,
    iconClass: 'bg-[#e9f2fb] text-[#2b6cb0]',
    title: 'Partner-trained Agents',
    text: 'Experienced teams handle subscription and billing questions.',
  },
  {
    icon: <FiMessageSquare className="h-5 w-5" />,
    iconClass: 'bg-[#fff1e8] text-[var(--brand-accent)]',
    title: 'Clear Communication',
    text: 'Straightforward answers, quick follow-up, and guided next steps.',
  },
];

export default function TrustBar() {
  return (
    <section className="px-5 py-16 sm:px-8">
      <div className="mx-auto max-w-7xl">

        {/* Section heading */}
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-extrabold tracking-tight text-[var(--brand-ink)] sm:text-5xl">
            Built for a seamless<br />care experience
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-[var(--text-muted)]">
            Modern support, fast responses, and a calm interface that guides you through every step of the cancellation process.
          </p>
        </div>

        {/* 4-column items */}
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map(item => (
            <div
              key={item.title}
              className="rounded-2xl border border-[#e8edf5] bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <div className={`mb-4 flex h-12 w-12 items-center justify-center rounded-xl ${item.iconClass}`}>
                {item.icon}
              </div>
              <h3 className="text-base font-semibold text-[var(--brand-ink)]">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[var(--text-muted)]">{item.text}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}